import React, { Component } from 'react';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';


import Page from '../../../components/Page';
import DataTable from '../../../components/DataTable';
import { TabHolder, Tab } from '../../../components/Tabs';
import Modal from '../../../components/Modal';
import BlankState from '../../../components/BlankState';

import { getAgents, getBranches } from '../../../utils/apiService';
import { saveAgent, updateAgent, listAgents } from '../../../actions/agents';

class Agents extends Component {

    constructor(props) {
        super(props);

        this.state = {
            agents: [],
            branches: [],
            agent: {
                    id: "",
                    name: "",
                    frontend_url: "",
                    postal_address: "",
                    tra_pin: "",
                    intermediary_type: "",
                    bank_account_number: "",
                    bank_name: "",
                    ira_reg: "",
                    certificate: "",
                    email: "",
                    phone: "",
                    company_logo: null
            },
            agents_loading: true,
            active_agent: {}
        };
    }

    componentDidMount() {
        getAgents()
            .then((response) => {
                this.setState({ agents: response.data, agents_loading: false })
            })

        getBranches()
            .then((response) => {
                this.setState({ branches: response.data })
            })
    }

    editAgent(agent) {
        this.setState({ active_agent: agent })
    }



    onChange = (e) => {
        e.preventDefault();

        const { agent } = this.state;
        const { name, value } = e.target;

        this.setState({
            agent: {
                ...agent,
                [name]: value
            }
        });

    }


    onUpdateAgent = (e) => {
        e.preventDefault()

        const { agent, active_agent } = this.state

        const updatedAgent = {
            id: active_agent.id,
            name: agent.name,
            code: agent.code
        };


        this.props.updateAgent(updatedAgent);
    }

    onSubmitAgent = (e) => {
        e.preventDefault();

        let agent = {
            firstname: this.state.agent.first_name,
            lastname: this.state.agent.last_name,
            other_names: this.state.agent.other_names,
            username: this.state.agent.username,
            email: this.state.agent.email,
            phone: this.state.agent.phone,
            ira_reg: this.state.agent.ira_reg,
            bank_account_number: this.state.agent.bank_account_number,
            bank_name: this.state.agent.bank_name,
            credit_limit: this.state.agent.credit_limit,
            commission_rate: this.state.agent.commission_rate

        };

        this.props.saveAgent(agent)
    }


    render() {
        

        const menuItems = [
            { id: "all-agents", name: "All Agents", active: true },
            { id: "agent-premiums", name: "Agents by Premiums" },
            { id: "add-agent", name: "Add Agent" }
        ]

        let { agents, active_agent, agents_loading } = this.state


        return (
            <Page isAdminPage={true} pageTitle="Agents">
                <div className="clearfix">
                    <TabHolder menuItems={menuItems}>

                        <Tab menuId={menuItems[0].id} isActive={true}>
                            {
                                agents.length > 0 ?
                                    <DataTable
                                        tableId="agents-table"
                                        columnTitles={["Name", "Email", "Phone Number", "Join date", "Actions"]}>
                                        {
                                            agents.map((agent, index) => {
                                                return (
                                                    <tr>
                                                        <td>{agent.name}</td>
                                                        <td>{agent.email}</td>
                                                        <td>{agent.phone}</td>
                                                        <td>{agent.ira_reg}</td>
                                                        <td>
                                                            <button className="btn btn-danger btn-sm">
                                                                { true ? 'De-Activate' : 'Activate' }
                                                            </button>
                                                            <button className="btn btn-warning btn-sm">
                                                                Edit
                                                            </button>
                                                        </td>
                                                    </tr>
                                                )
                                            })
                                        }
                                    </DataTable>
                                    :
                                    <BlankState
                                        data={agents}
                                        dataName="Agents"
                                        isDataLoading={agents_loading} />
                            }


                            <Modal
                                title="Edit Agents"
                                className="edit-agents-modal"
                                closable={true}>

                                <updateAgent
                                    agent={active_agent}
                                    onSubmitFn={this.onUpdateAgent}
                                    onChangeFn={this.onChange} />
                            </Modal>
                        </Tab>


                        <Tab menuId={menuItems[1].id}>
                            <DataTable
                                tableId="agent-premiums-table"
                                columnTitles={["Name", "Email", "Phone Number", "Join date", "Actions"]}>

                                <tr>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                </tr>

                            </DataTable>
                        </Tab>

                        <Tab menuId={menuItems[2].id}>
                        <div className="col-md-6">
                         <form   
                            className="form-horizontal" 
                            noValidate
                            onSubmit={ this.onSubmitAgent }>
                                    <div className="form-group">
                                        <label className="control-label col-md-4">First Name: <span className="text-danger">*</span></label>
                                        <div className="col-md-8">
                                            <input type="text" onChange={this.onChange} className="form-control" name="first_name" required />
                                        </div>
                                    </div>

                                    <div className="form-group">
                                        <label className="control-label col-md-4">Last Name: <span className="text-danger">*</span></label>
                                        <div className="col-md-8">
                                            <input type="text" onChange={this.onChange} className="form-control" name="last_name" required />
                                        </div>
                                    </div>

                                    <div className="form-group">
                                        <label className="control-label col-md-4">Other Names:</label>
                                        <div className="col-md-8">
                                            <input type="text" onChange={this.onChange} className="form-control" />
                                        </div>
                                    </div>

                                    <div className="form-group">
                                        <label className="control-label col-md-4">Username: <span className="text-danger">*</span></label>
                                        <div className="col-md-8">
                                            <input type="text" onChange={this.onChange} className="form-control" name="username" required />
                                        </div>
                                    </div>

                                    <div className="form-group">
                                        <label className="control-label col-md-4">Email: <span className="text-danger">*</span></label>
                                        <div className="col-md-8">
                                            <input type="text" onChange={this.onChange} className="form-control" name="email" required />
                                        </div>
                                    </div>

                                    <div className="form-group">
                                        <label className="control-label col-md-4">Phone Number: <span className="text-danger">*</span></label>
                                        <div className="col-md-8">
                                            <input type="text" onChange={this.onChange} className="form-control" name="phone" required />
                                        </div>
                                    </div>

                                    <div className="form-group">
                                        <label className="control-label col-md-4">IRA Registration: <span className="text-danger">*</span></label>
                                        <div className="col-md-8">
                                            <input type="text" onChange={this.onChange} className="form-control" name="ira_reg" required />
                                        </div>
                                    </div>

                                    <div className="form-group">
                                        <label className="control-label col-md-4">Account Number: <span className="text-danger">*</span></label>
                                        <div className="col-md-8">
                                            <input type="text" onChange={this.onChange} className="form-control" name="account_no" required />
                                        </div>
                                    </div>
                                    
                                    <div className="form-group">
                                        <label className="control-label col-md-4">Credit Limit: <span className="text-danger">*</span></label>
                                        <div className="col-md-8">
                                            <input type="text" onChange={this.onChange} className="form-control" name="credit_line" required />
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <label className="control-label col-md-4">Credit Period: <span className="text-danger">*</span></label>
                                        <div className="col-md-8">
                                            <input onChange={this.onChange} className="form-control" name="credit_period" required />
                                        </div>
                                    </div>
                                    <div className="col-md-8 col-md-offset-4">
                                        <button type="submit" className="btn btn-primary">
                                            <i className="icon ion-checkmark"></i> Create Agent
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </Tab>
                    </TabHolder>
                </div>
            </Page>
        );
    }
}

const mapStateToProps = (state, ownProps) => ({
    agent: state.agent,
    agents: state.agents
});

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({ listAgents, updateAgent, saveAgent }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Agents);


// WEBPACK FOOTER //
// ./src/pages/dashboard/agents/Agents.jsx